import React from "react";
import liracrypt from "../../components/Liracrypt/liracrypt";
import { Form, Row, Col, Modal, notification, Input, TimePicker } from "antd";
import moment from "moment";
import Date from "../../components/ReportFormGenerator/Date/Date";
import Idame from "../../components/ReportFormGenerator/Idame/Idame";
import CropDown from "../../components/ReportFormGenerator/CropDown/CropDown";
import Radio from "../../components/ReportFormGenerator/Radio/Radio";
import TextBox from "../../components/ReportFormGenerator/TextBox/TextBox";
import Int from "../../components/ReportFormGenerator/Int/Int";
import Decimal from "../../components/ReportFormGenerator/Decimal/Decimal";
import Range from "../../components/ReportFormGenerator/Range/Range";
import TypSubType from "../../components/ReportFormGenerator/TypSubType/TypSubType";
// import UniDrop from "../../components/ReportFormGenerator/UniDrop/UniDrop";
import UniDropAdv from "../../components/ReportFormGenerator/UniDrop/UniDropAdv";
import TypSubTypeDynamic from "../../components/ReportFormGenerator/TypSubType/TypSubTypeDynamic";
import ImgUpload from "./ImgUpload";
import StablePrime from "../../components/Tables/StablePrime";
import RoutePage from "../../components/RoutePage";
import FileController from "./FileController";
import CheckboxPicker from "../../components/ReportFormGenerator/Checkbox/Checkbox";
import GilDropdown from "../../components/ReportFormGenerator/GilDropdown";
import Time from "../../components/ReportFormGenerator/Date/Time";
import ImageSniper from "./ImageSniper";
import GilMultiRow from "../../components/ReportFormGenerator/GilMultiRow";
import SparkTable from "./SparkTable";
import GilMultiRowAddNew from "../../components/ReportFormGenerator/GilMultiRowAddNew";
import MultiControl from "../../components/ReportFormGenerator/MultiControl";
import ImageSniperAddNew from "./ImageSniperAddNew";
import FlameTable from "./FlameTable";
import DynamicCharts from "../../components/DynamicCharts";
import DynamicBlock from "../../components/DynamicBlock";
import DropdownTree from "../../components/ReportFormGenerator/DropdownTree";
import KPIColorSetter from "../../components/KPIColorSetter";
import StaticDropdownTree from "../../components/ReportFormGenerator/StaticDropdownTree";
import ColorDropdown from "../../components/ReportFormGenerator/ColorDropdown";
import LiveDataControl from "./LiveDataControl";
import QCElement from "./QCElement";
import HyperLink from "../../components/HyperLink";
import ZenActionBtn from "../../components/ZenActionBtn";
import ScrollBlock from "../../components/ScrollBlock";
import MultiTextBox from "./MultiTextBox";
import MultiDecimalControl from "./MultiDecimalControl";
import MultiIntControl from "./MultiIntControl";
import MultiDropdown from "./MultiDropdown";
import StSerialBlock from "./StSerialBlock";
import MultiDropdownTree from "../../components/ReportFormGenerator/MultiDropdownTree";
import Slicer from "../../components/Slicer";
import SingleValDynamicDropdown from "../../components/SingleValDynamicDropdown";
import MultiText from "../../components/MultiText";
import ImageSlideShow from "../ImageSlideShow";
import DropCheck from "../../components/DropCheck";
import NewTabBtns from "../../components/NewTabBtns";
import OutputBlocks from "../../components/OutputBlocks";
import SelectBtns from "../../components/SelectBtns";
import LikeBtn from "../../components/LikeBtn";
import StarRating from "../../components/StarRating";
import BooleanDrop from "../../components/ReportFormGenerator/UniDrop/BooleanDrop";

const ZenFormInput = ({
    urlData,
    textColor,
    queryLayout,
    childType,
    controlHeight,
    rows,
    style,
    form,
    name,
    pname,
    labelColSpan,
    label,
    defaultValue = '',
    typ,
    pageType,
    disabled,
    source,
    sourceParams,
    auxParams,
    key,
    format,
    errorMessage,
    required,
    placeHolder,
    options,
    defaultFrom,
    defaultTo,
    data,
    isIST,
    url,
    colSpan,
    includeAll,
    extraData,
    multiSelect,
    modalData,
    modalKey,
    searchable,
    height,
    children,
    LocalDict,
    header,
    footer,
    onChange
}) => {
    // console.log(defaultValue);
    // if (typ === "datePicker" || typ === "dateTimePicker") {
    //   dateSets[name] = format;
    // }
    let DefaultFrom = moment().format(format);
    let DefaultTo = moment().format(format);
    if (typ === "rangePicker" && data) {
        if (data["defaultFrom"]) {
            DefaultFrom = moment().add(data["defaultFrom"], "days").format(format);
        }
        if (data["defaultTo"] && data) {
            DefaultTo = moment().add(data["defaultTo"], "days").format(format);
        }
    }
    if (typ === "slicer" && data) {
        if (data["defaultFrom"]) {
            DefaultFrom = moment().add(data["defaultFrom"], "days").format(format);
        }
        if (data["defaultTo"] && data) {
            DefaultTo = moment().add(data["defaultTo"], "days").format(format);
        }
    }

    const { TextArea } = Input;



    if (modalData && modalKey) {
        defaultValue = modalData[modalKey];
    };


    const textContainer = (list) => (
        list ?
            <div className="modal-element-text-container">
                {
                    list.map((item, index) => (
                        <p style={item.style} key={index}>{item.text}</p>
                    ))
                }
            </div> : <></>
    );

    return (
        <>
            {/* {
                typ?.includes('multi') ? (
                    <Col span={colSpan ? colSpan : 24}>
                        <MultiControl
                            elem={data}
                            input_type={typ}
                        />
                    </Col>
                ) : <></>
            } */}
            {
                typ === 'dynamicChart' ?
                    <Col span={colSpan || 24}>
                        <DynamicCharts
                            name={name}
                            defaultValue={defaultValue}
                            label={label}
                            form={form}
                            LocalDict={LocalDict}
                        />
                    </Col> : <></>
            }
            {
                typ === 'dynamicBlock' ?
                    <Col span={colSpan || 24}>
                        <DynamicBlock
                            name={name}
                            defaultValue={defaultValue}
                            label={label}
                            form={form}
                        />
                    </Col> : <></>
            }
            {typ === "datePicker" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <Date
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        bg="transparent"
                        name={name}
                        form={form}
                        label={label}
                        format={format}
                        required={required}
                        disabled={disabled}
                        defaultValue={
                            modalData && modalKey
                                ? moment(modalData[modalKey]).format(format)
                                : defaultValue?.toString()
                                    ? moment().add(defaultValue, 'days').format(format)
                                    : ""
                        }
                        errorMessage={
                            errorMessage ? errorMessage : "Please Select " + label
                        }
                        placeholder={placeHolder}
                        isIST={isIST ? isIST : false}
                    />
                    {textContainer(footer)}

                </Col>
            ) : (
                <></>
            )}
            {typ === "label" ? (
                <Col span={colSpan ? colSpan : 24}>
                    <p style={{ color: 'white', ...data.style }} title={label}>{label}</p>
                </Col>
            ) : (
                <></>
            )}
            {typ === "invisibleControl" ? (
                <>
                    <Form.Item
                        hidden
                        name={name}
                        initialValue={defaultValue}
                    />
                </>
            ) : (
                <></>
            )}
            {typ === "stable" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <StablePrime zenTable={true} url={data.api} data={{ ...data.params, ...extraData }} />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "route" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <RoutePage route={data.route} params={data.params} />
                    {textContainer(footer)}

                </Col>
            ) : (
                <></>
            )}
            {typ === "imageControl" ? (
                <>
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <ImageSniper labelCol={labelColSpan} height={height} name={name} label={label} data={data} form={form} required={required} disabled={disabled} />
                        {/* <ImgUpload labelCol={labelColSpan} height={height} name={name} label={label} data={data} form={form} required={required} disabled={disabled} /> */}
                        {textContainer(footer)}

                    </Col>
                </>
            ) : (
                <></>
            )}
            {typ === "imageControlAddNew" ? (
                <>
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <ImageSniperAddNew
                            height={height}
                            form={form}
                            hideLabel={data.hideLabel}
                            placeholder={placeHolder || "Enter " + label}
                            data={data}
                            labelCol={labelColSpan ? labelColSpan : 8}
                            name={name}
                            label={label}
                            required={required}
                            disabled={disabled}
                            errorMessage={
                                errorMessage ? errorMessage : "Please Select " + label
                            }
                            defaultValue={defaultValue ? defaultValue : null}
                        />
                        {textContainer(footer)}
                    </Col>
                </>
            ) : (
                <></>
            )}
            {
                typ === "fileControl" ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <FileController labelCol={labelColSpan} height={height} name={name} label={label} data={data} form={form} required={required} disabled={disabled} />
                        {textContainer(footer)}
                    </Col>
                ) : (
                    <></>
                )
            }
            {typ === "rangePicker" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}

                    <Range
                        minDate={data.minDate}
                        maxDate={data.maxDate}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        bg="transparent"
                        placeholder={placeHolder}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Select " + label
                        }
                        disabled={disabled ? disabled : false}
                        required={required}
                        name={name}
                        format={format}
                        label={label}
                        isIST={isIST ? isIST : false}
                        defaultValue={
                            modalData && modalKey
                                ? [
                                    moment(defaultFrom).format(format),
                                    moment(defaultTo).format(format),
                                ]
                                : DefaultFrom || DefaultTo
                                    ? [
                                        DefaultFrom
                                            ? DefaultFrom
                                            : "",
                                        DefaultTo
                                            ? DefaultTo
                                            : "",
                                    ]
                                    : null
                        }
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {
                typ === 'gilDropdown' ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <GilDropdown
                            LocalDict={LocalDict}
                            childType={childType}
                            data={data}
                            labelCol={labelColSpan ? labelColSpan : 8}
                            name={name}
                            label={label}
                            form={form}
                            required={required}
                            disabled={disabled}
                            errorMessage={
                                errorMessage ? errorMessage : "Please Select " + label
                            }
                            options={options ? Object.keys(options).map(x => {
                                return { label: options[x], value: x }
                            }) : [
                                { label: 'Yes', value: 'yes' },
                                { label: 'No', value: 'no' },
                            ]}
                            children={data.children || {}}
                            defaultValue={defaultValue?.toString() ? defaultValue?.toString() : null}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {
                typ === 'sparkTable' ? (
                    <Col span={colSpan ? colSpan : 12}>
                        {textContainer(header)}
                        <SparkTable
                            height={data.height}
                            LocalDict={LocalDict}
                            label={label}
                            labelCol={labelColSpan}
                            form={form}
                            api={data.api}
                            params={{ ...urlData, ...data.params }}
                            colSpan={colSpan ? colSpan : 12}
                        //  layoutPosition={layoutPosition}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {
                typ === 'imageCorousel' ? (
                    <Col span={colSpan ? colSpan : 12}>
                        {textContainer(header)}
                        <ImageSlideShow
                            api={data.api}
                            data={data.data}
                            params={data.params}
                            src={data.src}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {
                (typ === 'sparkTableAddNew' || typ === 'flameTable') ? (
                    <Col span={colSpan ? colSpan : 12}>
                        {textContainer(header)}
                        <FlameTable
                            height={data.height}
                            LocalDict={LocalDict}
                            label={label}
                            labelCol={labelColSpan}
                            form={form}
                            api={data.api}
                            params={data.params}
                            colSpan={colSpan ? colSpan : 12}
                        //  layoutPosition={layoutPosition}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {
                typ === 'gilMultiRow' ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <GilMultiRow
                            countLabel={data.countLabel || 'Row Count'}
                            form={form}
                            data={data}
                            labelCol={labelColSpan ? labelColSpan : 8}
                            name={name}
                            rowCountReadOnly={data.rowCountReadOnly}
                            label={label}
                            required={required}
                            disabled={disabled}
                            errorMessage={
                                errorMessage ? errorMessage : "Please Select " + label
                            }
                            options={options ? Object.keys(options).map(x => {
                                return { label: options[x], value: x }
                            }) : [
                                { label: 'Yes', value: 'yes' },
                                { label: 'No', value: 'no' },
                            ]}
                            children={children}
                            defaultValue={defaultValue ? defaultValue : null}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {
                typ === 'gilMultiRowAddNew' ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <GilMultiRowAddNew
                            form={form}
                            hideLabel={data.hideLabel}
                            placeholder={placeHolder || "Enter " + label}
                            data={data}
                            labelCol={labelColSpan ? labelColSpan : 8}
                            name={name}
                            label={label}
                            required={required}
                            disabled={disabled}
                            errorMessage={
                                errorMessage ? errorMessage : "Please Select " + label
                            }
                            defaultValue={defaultValue ? defaultValue : null}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {typ === "dateTimePicker" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <Date
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        name={name}
                        label={label}
                        form={form}
                        required={required}
                        isIST={isIST ? isIST : false}
                        disabled={disabled}
                        showTime={true}
                        defaultValue={defaultValue}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Select " + label
                        }
                        placeholder={placeHolder}
                        format={format ? format : "YYYY/MM/DD"}
                    />
                    {textContainer(footer)}

                </Col>
            ) : (
                <></>
            )}
            {typ === "timePicker" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <Time
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        name={name}
                        label={label}
                        form={form}
                        required={required}
                        isIST={isIST ? isIST : false}
                        disabled={disabled}
                        showTime={true}
                        defaultValue={defaultValue ? defaultValue : ''}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Select " + label
                        }
                        placeholder={placeHolder}
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "TypSubTyp" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <TypSubType
                        labelCol={labelColSpan ? labelColSpan : 8}
                        typDefault={auxParams?.typDefault}
                        subTypDefault={auxParams?.subTypDefault}
                        form={form}
                        url={"/" + source}
                        urlData={sourceParams}
                        typName={
                            auxParams?.typ_data_index ? auxParams["typ_data_index"] : "typ_data_index"
                        }
                        typLabel={
                            auxParams?.typLabel ? auxParams["typLabel"] : "typLabel"
                        }
                        typErrorMessage={
                            "Please Enter " + auxParams?.typLabel
                                ? auxParams?.typLabel
                                : "Type"
                        }
                        typRequired={auxParams?.typRequired}
                        typPlaceholder={`Select ${auxParams?.typLabel ? auxParams["typLabel"] : "typLabel"
                            }`}


                        subTypName={
                            auxParams?.subTyp_data_index
                                ? auxParams["subTyp_data_index"]
                                : "subTyp_data_index"
                        }
                        subTypMultiSelect={
                            auxParams?.subTypMultiSelect
                        }
                        subTypLabel={
                            auxParams?.subTypLabel
                                ? auxParams["subTypLabel"]
                                : "subTypLabel"
                        }
                        subTypErrorMessage={
                            "Please Enter " + auxParams?.subTypLabel
                                ? auxParams?.subTypErrorMessage
                                : "subTypErrorMessage"
                        }
                        subTypRequired={auxParams?.subTypRequired}
                        subTypPlaceholder={`Select ${auxParams?.subTypLabel
                            ? auxParams["subTypLabel"]
                            : "subTypLabel"
                            }`}
                        typDisabled={auxParams?.typReadOnly}
                        subTypSearchable={auxParams?.subTypSearchable}
                        typSearchable={auxParams?.typSearchable}
                        subTypDisabled={auxParams?.subTypReadOnly}
                        includeAllTyp={auxParams?.typIncludeAll ? auxParams["typIncludeAll"] : false}
                        includeAllSubTyp={auxParams?.subTypIncludeAll ? auxParams["subTypIncludeAll"] : false}
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {
                typ === 'TypSubTypDynamic' ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <TypSubTypeDynamic
                            typDefault={auxParams?.typDefault}
                            subTypDefault={auxParams?.subTypDefault}
                            labelCol={labelColSpan ? labelColSpan : 8}
                            form={form}
                            auxParams={auxParams}
                            subTypSearchable={auxParams.subTypSearchable}
                            typSearchable={auxParams?.typSearchable}
                            subTypDisabled={auxParams.subTypReadOnly}
                            typDisabled={auxParams.typReadOnly}
                            typName={
                                auxParams["typ_data_index"] ? auxParams["typ_data_index"] : "typName"
                            }
                            typPname={
                                auxParams["typ_data_index"] ? `p_${auxParams["typ_data_index"]}` : "typName"
                            }
                            typLabel={
                                auxParams["typLabel"] ? auxParams["typLabel"] : "typLabel"
                            }
                            typErrorMessage={
                                "Please Enter " + auxParams["typLabel"]
                                    ? auxParams["typLabel"]
                                    : "Type"
                            }
                            typRequired={auxParams["typRequired"]}
                            typPlaceholder={`Select ${auxParams["typLabel"] ? auxParams["typLabel"] : "typLabel"
                                }`}


                            subTypName={
                                auxParams["subTyp_data_index"]
                                    ? auxParams["subTyp_data_index"]
                                    : "subTypName"
                            }
                            subTypPname={
                                auxParams["subTyp_data_index"]
                                    ? `p_${auxParams["subTyp_data_index"]}`
                                    : "p_subTypName"
                            }
                            subTypLabel={
                                auxParams["subTypLabel"]
                                    ? auxParams["subTypLabel"]
                                    : "subTypLabel"
                            }
                            subTypErrorMessage={
                                "Please Enter " + auxParams["subTypLabel"]
                                    ? auxParams["subTypErrorMessage"]
                                    : "subTypErrorMessage"
                            }
                            subTypRequired={auxParams["subTypRequired"]}
                            subTypPlaceholder={`Select ${auxParams["subTypLabel"]
                                ? auxParams["subTypLabel"]
                                : "subTypLabel"
                                }`}
                            //    disabled={disabled}
                            includeAllTyp={auxParams["typIncludeAll"] ? auxParams["typIncludeAll"] : false}
                            typMultiSelect={auxParams["typMultiSelect"] ? auxParams["typMultiSelect"] : false}
                            subTypMultiSelect={auxParams["subTypMultiSelect"] ? auxParams["subTypMultiSelect"] : false}
                            includeAllSubTyp={auxParams["subTypIncludeAll"] ? auxParams["subTypIncludeAll"] : false}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {typ === "radio" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <Radio
                        form={form}
                        name={name}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        label={label}
                        disabled={disabled}
                        required={required}
                        defaultValue={defaultValue}
                        options={options ? Object.keys(options).map(x => {
                            return { label: options[x], value: x }
                        }) : [
                            { label: 'Yes', value: true },
                            { label: 'No', value: false },
                        ]}
                        onChangeConfMsg={data.onChangeConfMsg}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Select " + label
                        }
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {
                typ === 'boolean' ? (
                    <Col span={colSpan ? colSpan : 12}>
                        <BooleanDrop
                            placeHolder={placeHolder}
                            name={name}
                            disabled={disabled}
                            errorMessage={errorMessage}
                            label={label}
                            pnam={`p_${name}`}
                            required={required}
                            form={form}
                            defaultValue={defaultValue}
                        />
                    </Col>
                ) : <></>
            }
            {typ === "checkbox" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}

                    <CheckboxPicker
                        form={form}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        name={name}
                        disabled={disabled}
                        required={required}
                        defaultValue={defaultValue}
                        options={options ? Object.keys(options).map(x => {
                            return { label: options[x], value: x }
                        }) : [
                            { label: 'YEs', value: 'yes' },
                            { label: 'No', value: 'no' },
                        ]}
                        label={label}
                        onChange={(value) => { }}
                        errorMessage={errorMessage ? errorMessage : "Please Select " + label}
                    />
                    {textContainer(footer)}

                </Col>
            ) : (
                <></>
            )}
            {typ === "blankSpace" ? (
                <Col span={colSpan ? colSpan : 24} style={data.style}>
                    <></>
                </Col>
            ) : (
                <></>
            )}
            {typ === "line" ? (
                <Col span={colSpan ? colSpan : 24}>
                    <hr style={style} />
                </Col>
            ) : (
                <></>
            )}
            {typ === "multiText" ? (
                <Col span={colSpan ? colSpan : 24}>
                    <MultiText containerStyle={data.config?.containerStyle} data={data.data} src={data.src} api={data.api} params={data.params} />
                </Col>
            ) : (
                <></>
            )}
            {typ === "outputBlocks" ? (
                <Col span={colSpan ? colSpan : 24}>
                    <OutputBlocks data={data} />
                </Col>
            ) : (
                <></>
            )}
            {typ === "textBox" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <TextBox
                        textColor={textColor}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        type={data.textWrap ? "textArea" : "input"}
                        name={name}
                        label={label}
                        disabled={disabled}
                        maxLength={data.maxLength}
                        required={required}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Enter " + label
                        }
                        rows={rows}
                        defaultValue={defaultValue ? defaultValue : null}
                        placeholder={placeHolder}
                    //   maxChar={400}
                    //   maxCharErrorMessage="Accepted only 400 Chars"
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "dropCheck" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <DropCheck
                        form={form}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        name={name}
                        disabled={disabled}
                        required={required}
                        defaultValue={defaultValue}
                        options={options ? Object.keys(options).map(x => {
                            return { label: options[x], value: x }
                        }) : [
                            { label: 'YEs', value: 'yes' },
                            { label: 'No', value: 'no' },
                        ]}
                        label={label}
                        onChange={(value) => { }}
                        errorMessage={errorMessage ? errorMessage : "Please Select " + label}
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "multiTextBox" ? (
                <Col span={24}>
                    {textContainer(header)}
                    <MultiTextBox
                        controlWidth={data.controlWidth}
                        controlsNo={data.controlsNo}
                        textColor={textColor}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        type={"input"}
                        name={name}
                        label={label}
                        disabled={disabled}
                        maxLength={data.maxLength}
                        required={required}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Enter " + label
                        }
                        rows={rows}
                        defaultValue={defaultValue ? defaultValue : null}
                        placeholder={placeHolder}
                    //   maxChar={400}
                    //   maxCharErrorMessage="Accepted only 400 Chars"
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "multiDropdown" ? (
                <>
                    {source === "mdict" ||
                        source === "usergroup" ||
                        source === "cropdown" ||
                        source === "data" ||
                        source === "dynamic" ? (
                        <Col span={colSpan ? colSpan : 24}>
                            {textContainer(header)}
                            <MultiDropdown
                                controlWidth={data.controlWidth}
                                controlsNo={data.controlsNo}
                                controlHeight={controlHeight}
                                onChange={onChange}
                                labelCol={labelColSpan ? labelColSpan : 8}
                                bg="transparent"
                                form={form}
                                colSpan={colSpan ? colSpan : 12}
                                multiSelect={multiSelect}
                                url={
                                    url
                                        ? url
                                        : source === "mdict"
                                            ? "/mdict"
                                            : source === "usergroup"
                                                ? "/usergroup"
                                                : source === "cropdown"
                                                    ? "/cropdown"
                                                    : source === "dynamic"
                                                        ? "/dynamicDropdown"
                                                        : ""
                                }
                                disabled={disabled}
                                onChangeConfMsg={data.onChangeConfMsg}
                                source={source}
                                options={options}
                                extraData={extraData}
                                urlData={sourceParams ? sourceParams : {}}
                                pname={pname ? pname : `p${name}`}
                                name={name}
                                label={label}
                                errorMessage={"Please Select " + label}
                                required={required}
                                placeholder={placeHolder}
                                defaultValue={defaultValue ? defaultValue : null}
                                includeAll={includeAll ? includeAll : false}
                                searchable={searchable ? searchable : false}
                            />
                            {textContainer(footer)}
                        </Col>
                    ) : (
                        <></>
                    )}
                </>
            ) : (
                <></>
            )}
            {typ === "multiIntControl" ? (
                <Col span={24}>
                    {textContainer(header)}
                    <MultiIntControl
                        controlWidth={data.controlWidth}
                        controlsNo={data.controlsNo}
                        textColor={textColor}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        type={"input"}
                        name={name}
                        label={label}
                        disabled={disabled}
                        maxLength={data.maxLength}
                        required={required}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Enter " + label
                        }
                        rows={rows}
                        defaultValue={defaultValue ? defaultValue : null}
                        placeholder={placeHolder}
                    //   maxChar={400}
                    //   maxCharErrorMessage="Accepted only 400 Chars"
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "multiDecimalControl" ? (
                <Col span={24}>
                    {textContainer(header)}
                    <MultiDecimalControl
                        controlWidth={data.controlWidth}
                        controlsNo={data.controlsNo}
                        textColor={textColor}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        type={"input"}
                        name={name}
                        label={label}
                        disabled={disabled}
                        maxLength={data.maxLength}
                        required={required}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Enter " + label
                        }
                        rows={rows}
                        defaultValue={defaultValue ? defaultValue : null}
                        placeholder={placeHolder}
                    //   maxChar={400}
                    //   maxCharErrorMessage="Accepted only 400 Chars"
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "liveDataControl" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <LiveDataControl
                        dataTyp={data.dataTyp}
                        format={data.format}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        type={rows ? 'textArea' : 'input'}
                        name={name}
                        label={label}
                        data={data}
                        extraParams={extraData}
                        disabled={disabled}
                        maxLength={data.maxLength}
                        required={required}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Enter " + label
                        }
                        rows={rows}
                        defaultValue={defaultValue ? defaultValue : null}
                        placeholder={placeHolder}
                    //   maxChar={400}
                    //   maxCharErrorMessage="Accepted only 400 Chars"
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "hyperLink" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <HyperLink
                        label={data.label}
                        zenPop={data.zenPop}
                        style={data.style}
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}
            {typ === "actionBtns" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <ZenActionBtn
                        actionBtns={data.actionBtn}
                        label={data.label}
                        zenPop={data.zenPop}
                        style={data.style}
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}

            {typ === "scrollBlock" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <ScrollBlock
                        text={data.text}
                        animation={data.animation}
                        style={data.style}
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}

            {typ === "textArea" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <TextArea
                        controlHeight={controlHeight}
                        style={{ width: '100%', minWidth: '100%' }}
                        maxLength={data.maxLength}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        value={defaultValue ? defaultValue : ""}
                        rows={rows}
                        disabled={disabled ? disabled : false}
                        placeholder={placeHolder}
                    />
                    {textContainer(footer)}
                </Col>
            ) : (
                <></>
            )}

            {typ === "intControl" ? (
                <Col className={name} span={colSpan ? colSpan : 24}>
                    {textContainer(header)}

                    <Int
                        min={data.min}
                        max={data.max}
                        textColor={textColor}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        placeholder={placeHolder}
                        name={name}
                        label={label}
                        disabled={disabled}
                        required={required}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Enter " + label
                        }
                        defaultValue={defaultValue}
                    />
                    {textContainer(footer)}

                </Col>

            ) : (
                <></>
            )}

            {typ === "decimalControl" ? (
                <Col span={colSpan ? colSpan : 24}>
                    {textContainer(header)}
                    <Decimal
                        min={data.min}
                        max={data.max}
                        textColor={textColor}
                        controlHeight={controlHeight}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        name={name}
                        label={label}
                        disabled={disabled}
                        defaultValue={defaultValue}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Enter " + label
                        }
                        required={required}
                    />
                    {textContainer(footer)}

                </Col>

            ) : (
                <></>
            )}
            {
                typ === 'dropdownTree' ?
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <DropdownTree
                            form={form}
                            elements={data.elements}
                            extraData={extraData}
                            data={data}
                        />
                        {textContainer(footer)}
                    </Col> : <></>
            }
            {
                typ === 'slicer' ?
                    <Slicer
                        queryLayout={queryLayout}
                        colSpan={colSpan ? colSpan : 24}
                        serialBlock={data.serialBlock}
                        labelCol={labelColSpan ? labelColSpan : 8}
                        form={form}
                        bg="transparent"
                        placeholder={placeHolder}
                        errorMessage={
                            errorMessage ? errorMessage : "Please Select " + label
                        }
                        disabled={disabled ? disabled : false}
                        required={required}
                        name={name}
                        format={format}
                        label={label}
                        isIST={isIST ? isIST : false}
                        defaultValue={
                            modalData && modalKey
                                ? [
                                    moment(defaultFrom).format(format),
                                    moment(defaultTo).format(format),
                                ]
                                : DefaultFrom || DefaultTo
                                    ? [
                                        DefaultFrom
                                            ? DefaultFrom
                                            : "",
                                        DefaultTo
                                            ? DefaultTo
                                            : "",
                                    ]
                                    : null
                        }
                    /> : <></>
            }
            {
                typ === 'multiLevelDropdown' ?
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <MultiDropdownTree
                            urlData={{ ...urlData }}
                            LocalDict={LocalDict}
                            form={form}
                            elements={data.elements}
                            extraData={extraData}
                            data={data}
                        />
                        {textContainer(footer)}
                    </Col> : <></>
            }
            {
                typ === 'buttonContainer' ?
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <NewTabBtns
                            links={data.links}
                        />
                        {textContainer(footer)}
                    </Col> : <></>
            }
            {
                typ === 'likeBtn' ?
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <LikeBtn
                            required={required}
                            errorMessage={errorMessage ? errorMessage : ("Please Select " + label || name)}
                            containerStyle={data.containerStyle}
                            form={form}
                            label={label}
                            name={name}
                            defaultValue={defaultValue}
                        />
                        {textContainer(footer)}
                    </Col> : <></>
            }
            {
                typ === 'rating' ?
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <StarRating
                            required={required}
                            errorMessage={errorMessage ? errorMessage : ("Please Select " + label || name)}
                            label={label}
                            containerStyle={data.containerStyle}
                            form={form}
                            name={name}
                            defaultValue={defaultValue}
                        />
                        {textContainer(footer)}
                    </Col> : <></>
            }
            {
                typ === 'selectBtns' ?
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <SelectBtns
                            required={required}
                            errorMessage={errorMessage ? errorMessage : ("Please Select " + label || name)}
                            data={data}
                            name={name}
                            form={form}
                        />
                        {textContainer(footer)}
                    </Col> : <></>
            }
            {
                typ === 'staticDropdownTree' ?
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <StaticDropdownTree
                            form={form}
                            name={name}
                            api={data.api}
                            defaultValue={defaultValue}
                            params={data.params}
                        />
                        {textContainer(footer)}
                    </Col> : <></>
            }
            {
                typ === 'kpiColorSetter' ?
                    <Col span={colSpan || 24}>
                        <KPIColorSetter
                            defaultValue={defaultValue}
                            initValue={data.initValue}
                            form={form}
                            label={label}
                            name={name}
                        />
                    </Col> : <></>
            }

            {typ === "dropDown" ? (
                <>
                    {source === "mdict" ||
                        source === "usergroup" ||
                        source === "cropdown" ||
                        source === "data" ||
                        source === "dynamic" ||
                        source === "dynamicSearch"
                        ? (
                            <Col span={colSpan ? colSpan : 24}>
                                {textContainer(header)}
                                <UniDropAdv
                                    LocalDict={LocalDict}
                                    minSearchLength={data.minSearchLength || 3}
                                    controlHeight={controlHeight}
                                    onChange={onChange}
                                    labelCol={labelColSpan ? labelColSpan : 8}
                                    bg="transparent"
                                    form={form}
                                    colSpan={colSpan ? colSpan : 12}
                                    multiSelect={multiSelect}
                                    url={
                                        url
                                            ? url
                                            : source === "mdict"
                                                ? "/mdict"
                                                : source === "usergroup"
                                                    ? "/usergroup"
                                                    : source === "cropdown"
                                                        ? "/cropdown"
                                                        : source === "dynamic"
                                                            ? "/dynamicDropdown"
                                                            : ""
                                    }
                                    disabled={disabled}
                                    onChangeConfMsg={data.onChangeConfMsg}
                                    source={source}
                                    options={options}
                                    extraData={extraData}
                                    urlData={sourceParams ? sourceParams : {}}
                                    pname={pname ? pname : `p${name}`}
                                    name={name}
                                    label={label}
                                    errorMessage={"Please Select " + label}
                                    required={required}
                                    placeholder={placeHolder}
                                    defaultValue={defaultValue ? defaultValue : null}
                                    includeAll={includeAll ? includeAll : false}
                                    searchable={searchable ? searchable : false}
                                />
                                {textContainer(footer)}
                            </Col>
                        ) : (
                            <></>
                        )}
                </>
            ) : (
                <></>
            )}
            {typ === "singleValDynamicDropdown" ? (
                <>
                    {source === "mdict" ||
                        source === "usergroup" ||
                        source === "cropdown" ||
                        source === "data" ||
                        source === "dynamic" ||
                        source === "dynamicSearch"
                        ? (
                            <>
                                {textContainer(header)}
                                <SingleValDynamicDropdown
                                    pageType={pageType}
                                    minSearchLength={data.minSearchLength || 3}
                                    controlHeight={controlHeight}
                                    onChange={onChange}
                                    labelColSpan={labelColSpan ? labelColSpan : 8}
                                    bg="transparent"
                                    form={form}
                                    colSpan={colSpan ? colSpan : 12}
                                    multiSelect={multiSelect}
                                    url={
                                        url
                                            ? url
                                            : source === "mdict"
                                                ? "/mdict"
                                                : source === "usergroup"
                                                    ? "/usergroup"
                                                    : source === "cropdown"
                                                        ? "/cropdown"
                                                        : source === "dynamic"
                                                            ? "/dynamicDropdown"
                                                            : ""
                                    }
                                    disabled={disabled}
                                    onChangeConfMsg={data.onChangeConfMsg}
                                    source={source}
                                    options={options}
                                    extraData={extraData}
                                    sourceParams={sourceParams ? sourceParams : {}}
                                    pname={pname ? pname : `p${name}`}
                                    name={name}
                                    label={label}
                                    errorMessage={"Please Select " + label}
                                    required={required}
                                    placeholder={placeHolder}
                                    defaultValue={defaultValue ? defaultValue : null}
                                    includeAll={includeAll ? includeAll : false}
                                    data={data}
                                    searchable={searchable ? searchable : false}
                                />
                                {textContainer(footer)}
                            </>
                        ) : (
                            <></>
                        )}
                </>
            ) : (
                <></>
            )}
            {
                typ === 'qcElement' ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <QCElement
                            specId={data.specId}
                            recId={data.recId}
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {
                typ === 'colorDropDown' ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <ColorDropdown
                            controlHeight={controlHeight}
                            src={data.src}
                            api={data.api}
                            params={{ ...urlData, ...data.params }}
                            name={name}
                            form={form}
                            labelCol={labelColSpan}
                            defaultValue={defaultValue}
                            label={label}
                            placeholder={placeHolder}
                            required={required}
                            disabled={disabled}
                            searchable={searchable ? searchable : false}
                            options={options}
                            multiSelect={multiSelect}
                            errorMessage={
                                errorMessage ? errorMessage : "Please Enter " + label
                            }
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
            {
                typ === 'serialBlock' ? (
                    <Col span={colSpan ? colSpan : 24}>
                        {textContainer(header)}
                        <StSerialBlock
                            options={options}
                            submitOnClick={data.submitOnClick}
                            name={name}
                            form={form}
                            data={data}
                            defaultValue={defaultValue}
                            label={label}
                            required={required}
                            disabled={disabled}
                            errorMessage={
                                errorMessage ? errorMessage : "Please Enter " + label
                            }
                        />
                        {textContainer(footer)}
                    </Col>
                ) : <></>
            }
        </>
    );
};
export default ZenFormInput;